


































































































































import {Component, Prop, Watch, Vue} from 'vue-property-decorator';
import {Route} from 'vue-router';
import axios from 'axios';
import EditDialog from './PlywoodPriceListEditDialog.vue';
import CSimpleTable from '@/components/base/table/CSimpleTable.vue';
import CDeleteDialog from '@/components/base/dialog/CDeleteDialog.vue';

@Component({
    components: {
        CDeleteDialog,
        CSimpleTable,
        EditDialog,
    },
})
export default class PlywoodPriceList extends Vue {
    private loading: boolean = false;
    private data: any = null;

    private PAGINATION_ELEMENTS_SIZES = [
        {text: '15', value: 15},
        {text: '25', value: 25},
        {text: '50', value: 50},
        {text: '100', value: 100},
    ];

    get currentPage() {
        return +this.$route.query.page;
    }
    set currentPage(value: number) {
        this.$router.replace({
            name: 'plywoodPriceList',
            query: {page: String(value), size: String(this.currentSize)},
        });
    }

    get currentSize() {
        return +this.$route.query.size;
    }
    set currentSize(value: number) {
        this.$router.replace({
            name: 'plywoodPriceList',
            query: {page: String(this.currentPage), size: String(value)},
        });
    }

    get cardLoading() {
        return this.loading ? 'plywood lighten-1' : null;
    }

    @Watch('$route', {deep: true, immediate: true})
    onRouteChange(value: Route) {
        let page = +value.query.page,
            size = +value.query.size;
        if (!page || !size) {
            if (isNaN(page)) page = 1;
            if (isNaN(size)) size = 25;
            this.$router.replace({
                name: 'plywoodPriceList',
                query: {
                    page: String(page) || '1',
                    size: String(size) || '25',
                },
            });
            return;
        }
        this.getData();
    }

    async getData() {
        if (this.loading) return;
        const timerId = setTimeout(
            () => {
                this.loading = true;
            },
            this.data ? 100 : 0,
        );
        try {
            const {data} = await this.$http.get(`${this.$api.journals.plywoodPriceList}/GetAll`, {
                params: {
                    PageIndex: this.currentPage,
                    RowCount: this.currentSize,
                },
            });
            this.data = data;
        } finally {
            clearTimeout(timerId);
            this.loading = false;
        }
    }

    add() {
        if (this.loading) return;
        const cancelRequest = axios.CancelToken.source(),
            request = this.$http.get(`${this.$api.journals.plywoodPriceList}/GetCreate`);
        (this.$refs.editing as any).openAsync(request, cancelRequest, {
            saveCallback: (data: any) => this.save(data),
        });
    }

    edit(id: number) {
        if (this.loading) return;
        const cancelRequest = axios.CancelToken.source(),
            request = this.$http.get(`${this.$api.journals.plywoodPriceList}/GetEdit`, {
                params: {
                    id,
                },
            });
        (this.$refs.editing as any).openAsync(request, cancelRequest, {
            saveCallback: (data: any) => this.save(data),
        });
    }

    copy(id: number) {
        if (this.loading) return;
        const cancelRequest = axios.CancelToken.source(),
            request = this.$http.get(`${this.$api.journals.plywoodPriceList}/GetCopy`, {
                params: {
                    id,
                },
            });
        (this.$refs.editing as any).openAsync(request, cancelRequest, {
            saveCallback: (data: any) => this.save(data),
        });
    }

    onDelete(id: number) {
        (this.$refs.deleting as any).open(id, {
            deleteCallback: async (id: number) => {
                try {
                    const {data} = await this.$http.post(`${this.$api.journals.plywoodPriceList}/Delete`, null, {
                        params: {
                            id,
                        },
                    });
                    if (data.Dependencies) (this.$refs.deleting as any).update(data.Dependencies);
                    else {
                        this.data = data;
                        (this.$refs.deleting as any).close();
                    }
                } catch (err) {
                    console.error(err);
                }
            },
        });
    }
    onDeleteAll() {
        (this.$refs.deleting as any).open(null, {
            deleteCallback: async () => {
                try {
                    const {data} = await this.$http.post(`${this.$api.journals.plywoodPriceList}/DeleteAll`, null);
                    if (data.Dependencies) (this.$refs.deleting as any).update(data.Dependencies);
                    else {
                        this.data = data;
                        (this.$refs.deleting as any).close();
                    }
                } catch (err) {
                    console.error(err);
                }
            },
        });
    }

    async save(payload: any) {
        try {
            const {data} = await this.$http.post(`${this.$api.journals.plywoodPriceList}/Save`, payload, {
                is400ErrorHandled: true,
            } as any);
            this.data = data;
            (this.$refs.editing as any).close();
        } catch (e) {
            (this.$refs.editing as any).setupErrors(e?.response?.data?.errors);
        }
    }
}
